import {AuthSliceInitalState} from '@/interface';
import { UserRole } from './enums';
/**
 * this file is maintained for having mock and dummy data
 * that will be often used to unit testing
 */

export const mockName = 'Jhon Doe';
export const mockEmail = 'jhondoe@example.com';
export const mockAge = 30;
export const mockAddress = '123 Main Street, Springfield, IL 62704, USA';
export const mockPhone = '8234567890';
export const mockProfileUrl = 'https://www.example.com';

/**
 * mock slices
 */

export const mockAuthSlice: AuthSliceInitalState = {
    authData: {
        created_at: new Date().toISOString(),
        email_id: mockEmail,
        username: mockName,
        address: mockAddress,
        age: mockAge,
        phone: mockPhone,
        photo_url: mockProfileUrl,
        role: UserRole.PATIENT,
    },
    authFailure: false,
    authSuccess: false,
    isAuthenticated: false,
    isLoading: false,
    otp_attempts: 0,
    otp_email: '',
    otpTimer: new Date().toISOString(),
    persist: {
        authScreenType: 'patient',
    },
    specialistFormData: {
        name: '',
        email_id: '',
        phone: '',
        charge: null,
        designation: '',
        education: '',
        experience: null,
        license: null,
        specialization: '',
    },
    specialistCurrentStep: 1,
};
